import { SaleModel } from '../../../../types.ts';
import { Box, Flex, Text } from '@chakra-ui/react';
import { SaleDateDisplay } from './components/SaleDateDisplay.tsx';
import { SaleTypeDisplay } from './components/SaleTypeDisplay.tsx';
import { useActiveAuctionCardContent } from './hooks/useActiveAuctionCardContent.tsx';
import { EnterSaleButton } from './components/EnterSaleButton.tsx';
import { AuctionCard } from './components/AuctionCard.tsx';

export const ActiveAuctionCard = (model: SaleModel) => {
  const { description, saleTypeText, saleDate, buttonText, color, badgeText, saleUrl } =
    useActiveAuctionCardContent(model);

  const handleCardClick = () => {
    window.location.href = saleUrl;
  };

  return (
    <AuctionCard color={color} onClick={handleCardClick}>
      <Flex justify='space-between' direction={{ base: 'column-reverse', lg: 'row' }}>
        <Flex direction={'row'}>
          <Box hideBelow={'lg'} paddingY={'30px'} paddingLeft={'15px'} paddingRight={'70px'}>
            <EnterSaleButton buttonText={buttonText} badgeText={badgeText} />
          </Box>
          <Flex direction='column' fontSize='md' fontWeight='semibold' gap={2} my={4}>
            {description.map((text, index) => (
              <Text key={index}>{text}</Text>
            ))}
          </Flex>
        </Flex>
        <Flex hideBelow={'lg'} direction={'row'} gap={{ lg: '12px' }}>
          <SaleDateDisplay saleDate={saleDate} />
          <SaleTypeDisplay text={saleTypeText} color={color} />
        </Flex>
        <Flex hideFrom={'lg'} justify='space-between' direction={'row'}>
          <Box hideFrom={'lg'} paddingY={'30px'} paddingLeft={'15px'} paddingRight={'70px'}>
            <EnterSaleButton buttonText={buttonText} badgeText={badgeText} />
          </Box>
          <SaleTypeDisplay text={saleTypeText} color={color} />
        </Flex>
      </Flex>
    </AuctionCard>
  );
};
